import { render, staticRenderFns } from "./tagsList.vue?vue&type=template&id=fcb624a2&"
import script from "./tagsList.vue?vue&type=script&lang=js&"
export * from "./tagsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports